import { FieldValidator } from 'final-form';
import moment from 'moment';

import { urlRegex } from '~src/constants';

export const validatorEmail = (email: string): string | undefined =>
  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{1,64}$/i.test(email) ? 'invalid_email' : undefined;

export const isDueDateBeforeStartDate = (start: moment.Moment, due: moment.Moment) => {
  if(!start || !due) return;
  if(due.isBefore(start)) {
    return 'dueDateBeforeStartDate';
  }
}

export const validatorEmptyOr =
  <T>(validator: FieldValidator<T>): FieldValidator<T> =>
  (value: T) =>
    !value ? undefined : validator(value);

export const validatorRequired: FieldValidator<any> = (value?: any): string | undefined =>
  (!value && value !== 0) ||
  (typeof value === 'string' && value.trim() === '') ||
  (typeof value === 'object' && Object.keys(value).length === 0)
    ? 'required'
    : undefined;

export const validatorRequiredArr = (value?: any[]): string | undefined =>
  !value || value.length < 1 ? 'required' : undefined;

export const validatorUuid = (value: string): 'invalid_uuid' | undefined =>
  /^[a-f\d]{8}(-[a-f\d]{4}){3}-[a-f\d]{12}$/.test(value) ? undefined : 'invalid_uuid';

const minValue =
  (length: number) =>
  (value: string): string | undefined =>
    value && value.length < length ? `min_length_${length}` : undefined;
export const validatorMinValue6 = minValue(6);

export const validatorTrimmed = (value: string): 'not_trimmed' | undefined =>
  value && value.trim() !== value ? 'not_trimmed' : undefined;

export const validatorDecimal = (value: string): string | undefined =>
  value && !/^[+-]?\d*[.,]?\d{1,2}?$/.test(value) ? 'invalid_decimal' : undefined;

const maxLengthLink =
  (length: number) =>
  (value: string): string | undefined => {
    // tslint:disable-next-line:max-line-length
    let valueWithOutLink = null;
    if (value) {
      const urlRegexCheck = new RegExp(urlRegex, 'g');
      valueWithOutLink = value.replace(urlRegexCheck, '');
    }
    return valueWithOutLink && valueWithOutLink.length > length ? `max_length_${length}` : undefined;
  };

export const maxLength =
  (length: number, err: string = '') =>
  (value: string): string | undefined => {
    return value && value.length > length ? (err ? err : `max_length_${length}`) : undefined;
  };

export const validatorMaxLength40 = maxLength(40);
export const validatorMaxLength80 = maxLength(80);
export const validatorMaxLength1000 = maxLength(1000);

export interface ErrorWithParams {
  message: string;
  params:  Record<string, string>
}

export const maxLengthWithErrorParams = (length: number) =>
  (value: string): ErrorWithParams | undefined => {
    return value && value.length > length ? {message: 'max_length', params: {len: String(value.length), max: String(length)}} : undefined;
  };
export const validatorMaxLength5000 = maxLengthWithErrorParams(5000);

export const validatorMaxLengthLink500 = maxLengthLink(500);
export const validatorMaxLengthLink1000 = maxLengthLink(1000);

const minNumber =
  (min = 1) =>
  (value: string): string | undefined =>
    value && parseInt(value, 10) < min ? `min_number_${min}` : undefined;
export const validatorMinNumber1 = minNumber();
